import { registerAction } from '../../Action'

const LOAD_ASSET_CSV_ROW_COUNT = 'LOAD_ASSET_CSV_ROW_COUNT'

const reducer = (state = {}, action) => ({
  ...state,
  assetCSVRowCount: parseInt(action.payload.meta.total, 10),
})

const loadAssetCSVRowCount = registerAction(LOAD_ASSET_CSV_ROW_COUNT, {
  reducer,
})

export default loadAssetCSVRowCount
